import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../../app/services/auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private router: Router, public authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modifiedReq = req.clone({
      headers: req.headers.set('X-Client-Type', 'web')
    });

    return next.handle(modifiedReq).pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status === 401 || error.status === 500) {
          Swal.fire({
            icon: 'error',
            title: 'No autorizado',
            text: 'Tu sesión ha expirado o tu token es inválido.',
          }).then(() => {
            // Cerrar sesión y redirigir al login
            this.authService.logout();
          });
        } else{
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.error.message,
          });
        }

        return throwError(() => error);  
      })
    );
  }
}
